import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import './StandardCreditCardPlus.scss';
import { Link } from 'components/navigation/Link/Link';

const NotQualifiedPlusCard = props => {
  const { onClickActionItems } = props;

  return (
    <FlexContainer className={'CreditCardPlus m-padB20'}>
      <FlexContainer
        className={
          ' bgNeutral450 widthNotQualified m-height204px borderRadius8 align-items-center m-justify-center padLR30 padTB30'
        }
      >
        <FlexContainer
          className={' m-flex-column m-width240px text-center m-gap-18'}
        >
          <Label type={'Subtitle-2'} className={'fontWhite'}>
            You don’t qualify for any Sesame+ Pick cards today.&nbsp;
          </Label>
          <Label type={'Subtitle-2'} className={'fontWhite'}>
            Refer to your{' '}
            <Link
              type={'Subtitle-2'}
              linkClassName="contrast"
              onClickCallback={onClickActionItems}
            >
              <span className="fontYellow100 text-underline">action items</span>
            </Link>{' '}
            for additional insights.
          </Label>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default NotQualifiedPlusCard;
